export const StoreRoutes = () => {
    const routes = [
          "/",
          "/produtos", 
          "/produtos-vencidos",
          "/usuarios",
          "/configuracao"
      ]
    return routes;
}
  